import { getNextStep, Step } from "./states";
import {
  TransactionState,
  handleCardCaptured,
  handleDataStructured,
  handleISO,
  handleEncryption,
  handleRouting,
  handleAuthorization
} from "./transitions";

export function runStep(state: TransactionState): TransactionState {
  const next = getNextStep(state.currentStep);

  if (!next) return state;

  let result;

  switch (next) {
    case "CARD_CAPTURED":
      result = handleCardCaptured(state);
      break;

    case "DATA_STRUCTURED":
      result = handleDataStructured(state);
      break;

    case "ISO_BUILT":
      result = handleISO(state);
      break;

    case "ENCRYPTED":
      result = handleEncryption(state);
      break;

    case "ROUTED":
      result = handleRouting(state);
      break;

    case "AUTHORIZED":
      result = handleAuthorization(state);
      break;

    case "COMPLETED":
      return {
        ...state,
        currentStep: "COMPLETED"
      };

    default:
      return state;
  }

  return {
    ...result.state,
    currentStep: next as Step,
    history: [...state.history, { ...result.log, id: crypto.randomUUID() }]
  };
}